import React from 'react'

export default function X({ size }) {
    return (
        <svg width={size ?? 14} height={size ?? 14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L13 13M1 13L13 1L1 13Z" stroke="#C6C6CA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
